import type { SeasonId } from '@somnhold/content';
import { halloween } from './halloween.ts';
import type { SeasonTheme } from './types.ts';

export * from './types.ts';

/** Every holiday's look, by season id. A season without an entry here plays with the ordinary look. */
export const SEASON_THEMES: Partial<Record<SeasonId, SeasonTheme>> = {
  halloween,
};

export const themeOf = (season: SeasonId | undefined): SeasonTheme | undefined => (season ? SEASON_THEMES[season] : undefined);
